<template>
  <div class="head-card mb-2">
    <div class="head-card-bottom">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats' }"
        pill
        exact
      >
        {{ $t('dsppartners.navigation.total') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats-sources' }"
        pill
      >
        {{ $t('dsppartners.navigation.sources') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats-campaigns' }"
        pill
      >
        {{ $t('dsppartners.navigation.campaigns') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats-rtb-partners' }"
        pill
      >
        {{ $t('dsppartners.navigation.rtb_partners') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats-country', params: { id: $route.params.id } }"
        pill
      >
        {{ $t('dsppartners.navigation.geo') }}
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
        :to="{ name: 'dashboard-dsppartner-stats-device', params: { id: $route.params.id } }"
        pill
      >
        {{ $t('dsppartners.navigation.devices') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'StatsNavigation',
  components: {
    BButton,
  },
  directives: {
    Ripple,
  },
}
</script>

<style scoped lang="scss">
.head-card-bottom {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
</style>
